<template>
  <div v-if="src" class="iframe__wrapper" :style="iframeWrapperStyles">
    <iframe :src="iframeSrc" v-bind="iframeAttrs" :class="iframeDynamicClass" />
  </div>
</template>

<script>
import { removeEndingSlashes, parseUrl } from '@/plugins/helper'
import { PROP_TYPES, propValidator } from '@/utils/validators'
import { DEFAULT_IFRAME_WIDTH, DEFAULT_IFRAME_HEIGHT } from 'enums/media-center'
import { urlFormatters } from '@/utils/mixins/general'
import { ELEMENT_WIDTH, ELEMENT_HEIGHT } from 'enums/data-attributes'

export default {
  name: 'AIframe',
  mixins: [urlFormatters],
  inheritAttrs: false,
  props: {
    src: propValidator([PROP_TYPES.STRING], false),
    entityType: propValidator([PROP_TYPES.STRING], false),
    ignoreIframeSizes: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  data() {
    return {
      iframeSrc: null
    }
  },
  computed: {
    srcAddress() {
      return removeEndingSlashes(parseUrl(this.src).address)
    },
    isDimensionsExistInDataAttributes() {
      return this.$attrs[ELEMENT_WIDTH] || this.$attrs[ELEMENT_HEIGHT]
    },
    iframeDynamicClass() {
      return {
        absolute: !this.isDimensionsExistInDataAttributes
      }
    },
    parsedWidthFromAttrs() {
      return +String(this.$attrs.width || '').replace(/px$/im, '')
    },
    parsedHeightFromAttrs() {
      return +String(this.$attrs.height || '').replace(/px$/im, '')
    },
    iframeWidth() {
      return this.isWidthAndHeightValid
        ? this.$attrs.width
        : DEFAULT_IFRAME_WIDTH
    },
    iframeHeight() {
      return this.isWidthAndHeightValid
        ? this.$attrs.height
        : DEFAULT_IFRAME_HEIGHT
    },
    isWidthAndHeightValid() {
      return this.parsedWidthFromAttrs > 0 && this.parsedHeightFromAttrs > 0
    },
    iframeAspectRatio() {
      return this.iframeWidth / this.iframeHeight
    },
    iframeAttrs() {
      return {
        ...this.$attrs,
        ...this.dimensionsAttrs
      }
    },
    dimensionsAttrs() {
      const dataWidth = this.$attrs[ELEMENT_WIDTH]
      const dataHeight = this.$attrs[ELEMENT_HEIGHT]

      return this.ignoreIframeSizes
        ? { width: dataWidth, height: dataHeight }
        : {
            width: dataWidth || this.iframeWidth,
            height: dataHeight || this.iframeHeight
          }
    },
    iframeWrapperStyles() {
      return this.ignoreIframeSizes || this.isDimensionsExistInDataAttributes
        ? {}
        : this.$helper.generateAspectRatioStyle(this.iframeAspectRatio)
    }
  },
  methods: {
    setIframeSource() {
      if (!this.src) return

      this.iframeSrc = this.src
    }
  },
  mounted() {
    this.setIframeSource()
  }
}
</script>

<style lang="scss" scoped>
.iframe__wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;

  iframe {
    &.absolute {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    &.mocked {
      background: $c--black;
    }
  }
}
</style>
